import {
  CompareOperator,
  createOptions,
  leadPhone,
} from "@/modules/crm/leads/constant";
import { Validate_Email } from "@/modules/crm/leads/graphql-queries/general-queries";
const {
  After,
  Before,
  Begins,
  Ends,
  Between,
  Equal,
  Does_not_equal,
  Includes,
  Does_not_includes,
  Greater_than,
  Less_than,
} = CompareOperator;

export const newLeadFormJson = {
  sections: [
    {
      id: "new-lead-section",
      // heading: "Create New Lead",
      // infoText: "Enter contact details to create a new lead for this appointment",
      fields: [
        {
          title: "First Name",
          value: "",
          name: "firstName",
          type: "text",
          required: true,
          placeholder: "Enter first name",
          rules: {
            required: true,
            limit: 50,
          },
        },
        {
          title: "Last Name",
          value: "",
          name: "lastName",
          type: "text",
          rules: {
            required: false,
            limit: 50,
          },
          customCode: { label: "[Lead LastName]", value: "Smith" },
          comparisionType: createOptions([
            Begins,
            Ends,
            Includes,
            Does_not_includes,
            Equal,
            Does_not_equal,
            // is_provided,
            // is_not_provided,
          ]),
        },
        {
          title: "Email",
          value: "",
          name: "email",
          type: "text",
          rules: {
            required: true,
            validation: "email",
            gqlValidate: {
              error: "The email already exists",
              query: Validate_Email,
            },
          },
          customCode: { label: "[Lead Email]", value: "jack@gmail.com" },
          comparisionType: createOptions([
            Begins,
            Ends,
            Includes,
            Does_not_includes,
            Equal,
            Does_not_equal,
            // is_provided,
            // is_not_provided,
          ]),
        },
        {
          ...leadPhone,
          customCode: { label: "[Lead Phone]", value: "(925) 293-8670" },
          comparisionType: createOptions([
            Begins,
            Ends,
            Includes,
            Does_not_includes,
            Equal,
            Does_not_equal,
            // is_provided,
            // is_not_provided,
          ]),
        },
      ],
    },
  ],
};
